module.exports = __webpack_public_path__ + "img/memory.fb146e95.svg";